<template>
  <model :feature-list="featureList" :page-data="pageData"></model>
</template>

<script>
import model from './model.vue'

export default {
  components: {
    model
  },
  data () {
    return {
      pageData: {
        overview: {
          label: '声像档案管理概览',
          title: '让照片、音频与视频资源从归集走向高效利用',
          description: '统一完成声像资源导入、整理著录、人物标注、内容检索与在线利用。',
          tags: ['资源归集', '整理著录', '智能检索', '在线利用'],
          panel: {
            title: '声像档案工作台',
            summaryLabel: '待整理声像资源',
            summaryValue: '1,842 件',
            rows: [
              { label: '待导入资源', value: '328 件', tone: 'primary' },
              { label: '缩略图生成', value: '96%', tone: 'positive' },
              { label: '人物标注', value: '74 条待确认', tone: 'warning' },
              { label: '检索索引', value: '已更新', tone: 'positive' }
            ],
            footer: '资源预览、著录与检索状态集中可见'
          },
          values: [
            { title: '统一管理', description: '多类型声像资源统一纳入档案体系。' },
            { title: '整理高效', description: '辅助完成预览、著录和信息标注。' },
            { title: '检索精准', description: '从内容和元数据中快速找到所需资源。' }
          ]
        },
        featureSection: {
          title: '连接声像档案整理与利用全流程',
          description: '让珍贵的影像、声音和图像资料拥有清晰的管理脉络，并更容易被发现和利用。'
        },
        process: {
          title: '让多媒体档案有序流转',
          description: '通过统一的归集、整理、检索和利用流程，提升声像资源的管理效率。',
          steps: [
            { title: '导入归集', description: '导入照片、音频与视频等多类资源。' },
            { title: '整理著录', description: '完成缩略图、封面、元数据和人物信息整理。' },
            { title: '智能检索', description: '通过人物、内容、元数据和图片快速查找。' },
            { title: '在线利用', description: '支持资源浏览、播放与业务场景调用。' }
          ]
        }
      },
      featureList: [
        {
          feature: '资源导入、整理著录与智能检索',
          description: [
            '支持照片、视频、音频导入，自动生成照片缩略图和视频封面，便于快速预览与归集。',
            '支持声像档案整理著录、人物信息标注和元数据自动捕获，完善资源描述信息。',
            '支持人脸检索、多人照片检索、元数据浏览、视频播放和以图搜图等利用方式。'
          ],
          src2: require('../../assets/images/solution-img-4.jpg')
        }
      ]
    }
  }
}
</script>
